import {
  AgentTrackerResponseSchema,
  LeadPipelineResponseSchema,
  LeadPivotResponseSchema,
  LeadReportExportSchema,
  PerformanceDayResponseSchema,
} from '@utazzo/shared';

import type { LeadPipelineKind, LeadPivotDimension } from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

export const getAgentTracker = async (from: string, to: string) => {
  const { data } = await apiClient.get<unknown>('/reports/leads/agent-tracker', {
    params: { from, to },
  });
  return AgentTrackerResponseSchema.parse(data);
};

export const getPerformanceDay = async (date: string) => {
  const { data } = await apiClient.get<unknown>('/reports/leads/performance-day', {
    params: { date },
  });
  return PerformanceDayResponseSchema.parse(data);
};

export const getPipeline = async (from: string, to: string, kind: LeadPipelineKind) => {
  const { data } = await apiClient.get<unknown>('/reports/leads/pipeline', {
    params: { from, to, kind },
  });
  return LeadPipelineResponseSchema.parse(data);
};

/**
 * Trigger a browser download of the agent tracker XLSX. Same
 * base64-decode + Blob ceremony as the import sample templates.
 */
export const downloadAgentTrackerExport = async (from: string, to: string): Promise<void> => {
  const { data } = await apiClient.get<unknown>('/reports/leads/agent-tracker/export', {
    params: { from, to },
  });
  const file = LeadReportExportSchema.parse(data);
  const bytes = Uint8Array.from(atob(file.contentBase64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = file.filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Defer revoke so Safari has time to start the download.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

export const getPivot = async (
  from: string,
  to: string,
  dimension: LeadPivotDimension,
  carryForwardOnly = false,
  lostFromSubStatusCode?: string,
  largeOnly?: boolean,
) => {
  const { data } = await apiClient.get<unknown>('/reports/leads/pivot', {
    params: {
      from,
      to,
      dimension,
      carryForwardOnly,
      lostFromSubStatusCode,
      ...(largeOnly ? { largeOnly: true } : {}),
    },
  });
  return LeadPivotResponseSchema.parse(data);
};
